module.exports = __webpack_public_path__ + "img/SC01_07.8e34a659.png";